import { useAffiliateCustomizationStore } from '~/store/affiliate-customization'

export default defineNuxtPlugin(async ({ $lendioCookies }) => {
  if (useRoute().path === '/healthcheck') {
    return
  }

  const allowedBypassHostSlugs = ['cornerbank']
  const host = window.location.hostname
  const {
    getNoAuthActiveAffiliateCustomizations,
    getNoAuthActiveAffiliateCustomizationsByHost
  } = useAffiliateCustomizationStore()

  const _query = useRoute().query
  const simpleParam = param => Array.isArray(param) ? param[0] : param
  const overrideHost = simpleParam(_query.overrideHost)
  const overrideId   = simpleParam(_query.overrideId)
  const affiliateId  = simpleParam(_query.affiliateId)

  const hostCanBypass = allowedBypassHostSlugs.some(slug => host.includes(slug))

  if (useRoute().path.startsWith('/guest/')) {
    const guestAffiliateId = (affiliateId || overrideId || $lendioCookies.get('guestAffiliateId', { tenantAgnostic: true }) || null)
    if (guestAffiliateId) {
      return await getNoAuthActiveAffiliateCustomizations(guestAffiliateId)
    }
  }

  if (hostCanBypass) {
    let overrideValue

    if (overrideId) {
      overrideValue = await getNoAuthActiveAffiliateCustomizations(overrideId)
    }

    if (overrideHost) {
      overrideValue = await getNoAuthActiveAffiliateCustomizationsByHost(overrideHost)
    }

    if (overrideValue) {
      return
    }
  }

  return await getNoAuthActiveAffiliateCustomizationsByHost(host)
})
